import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import CustomerFeedback from "./pages/CustomerFeedback";
import AdminFeedback from "./pages/AdminFeedback";
import AdminLogin from "./pages/AdminLogin";
import { isAuthenticated } from "./utils/auth";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CustomerFeedback />} />
        <Route path="/admin" element={isAuthenticated() ? <AdminFeedback /> : <AdminLogin onLogin={() => window.location.reload()} />} />
      </Routes>
    </BrowserRouter>
  );
}
